import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const lang = localStorage.getItem("language") || "en";

i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		fallbackLng: lang,
		lang: lang,
		interpolation: {
			escapeValue: false,
		},
		ns: [],
		defaultNS: ["translation"],
		react: {
			useSuspense: false,
		},
	});

export default i18n;
